import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftFinancialProps } from './props';
import { SarlaftFinancial } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftFinancial = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftFinancialProps) => {
    const onSubmit = (data: SarlaftFinancial) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('annualIncome', data?.annualIncome || '');
        formik?.setFieldValue('assets', data?.assets || '');
        formik?.setFieldValue(
            'annualExpenditure',
            data?.annualExpenditure || ''
        );
        formik?.setFieldValue('liabilities', data?.liabilities || '');
        formik?.setFieldValue(
            'otherAnnualIncome',
            data?.otherAnnualIncome || ''
        );
        formik?.setFieldValue('otherIncome', data?.otherIncome || '');
    }, [data]);

    return {
        formik,
    };
};
